import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const AITermsText = ({
  subject,
}: {
  subject: "Vehicle Suggestions" | "Vehicle Reviews" | "Vehicle Ratings";
}) => {
  return (
    <Box>
      <Typography variant="bodySmall" display="inline">
        ^{subject} are generated using AI and are subject to{" "}
      </Typography>
      <a href="https://www.auto-ux.io/terms-conditions/" target="_blank">
        <Typography variant="bodySmall" color="primary" display="inline">
          Auto-UX terms
        </Typography>
      </a>
    </Box>
  );
};

export default AITermsText;
